import { HttpService } from '@/shared/lib'

export class DeleteReservaProdutoService extends HttpService {
  async execute(idResponsavel: string, idProduto: string) {
    return this.http.delete(`/api/v2/ReservaDoProduto/responsavel/${idResponsavel}/produto/${idProduto}`)
  }
}
